// extracted by mini-css-extract-plugin
module.exports = {"details":"StepHeading_details__450RA","title":"StepHeading_title__UyR0F","large":"StepHeading_large__BIWje","description":"StepHeading_description__YcKE2"};